var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Activities',{attrs:{"title":"Point Earn Activities","items":_vm.result,"unit":"pts"}})
}
var staticRenderFns = []

export { render, staticRenderFns }